import React, { useRef } from 'react';
import DownloadReadyNotice from './DownloadReadyNotice';

function DownloadIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  );
}

function ReportDownloadActions({
  t,
  theme = 'light',
  isClientMode = false,
  pdfComplete = false,
  showDownloadCue = false,
  showDownloadNotice = false,
  onCloseDownloadNotice,
  onDownloadPdf,
  onDownloadCsv,
}) {
  const downloadRowRef = useRef(null);

  if (isClientMode) {
    return (
      <div className="download-row">
        <div className="download-row-inner">
          <div className="download-action-item">
            <span className="download-label">{t('report_download_transcript_label')}</span>
            <button
              onClick={onDownloadCsv}
              className="download-icon-button"
              aria-label={t('report_download_transcript_aria')}
              title={t('report_download_transcript_aria')}
            >
              <DownloadIcon />
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={downloadRowRef}
      className={`download-row${showDownloadCue ? ' download-row--selection-cue' : ''}`}
      data-guided-highlight-purpose={showDownloadCue ? 'Download your feedback report or annotated transcript.' : undefined}
    >
      {showDownloadNotice && (
        <DownloadReadyNotice
          anchorRef={downloadRowRef}
          t={t}
          theme={theme}
          onClose={onCloseDownloadNotice}
        />
      )}
      <div className="download-row-inner">
        <div className="download-action-item">
          <span className="download-label">{t('report_download_feedback_label')}</span>
          <button
            onClick={onDownloadPdf}
            className={`download-icon-button ${!pdfComplete ? 'disabled' : ''}`}
            disabled={!pdfComplete}
            aria-label={t('report_download_feedback_aria')}
            title={pdfComplete ? t('report_download_feedback_aria') : t('report_download_feedback_generating')}
          >
            <DownloadIcon />
          </button>
        </div>
        <div className="download-action-item">
          <span className="download-label">{t('report_download_transcript_label')}</span>
          <button
            onClick={onDownloadCsv}
            className="download-icon-button"
            aria-label={t('report_download_annotated_aria')}
            title={t('report_download_annotated_aria')}
          >
            <DownloadIcon />
          </button>
        </div>
      </div>
      {pdfComplete && (
        <span className="download-row-status download-row-status--hint">
          {t('report_download_feedback_note')}
        </span>
      )}
      {!pdfComplete && (
        <span className="download-row-status">{t('report_writing_report_status')}</span>
      )}
    </div>
  );
}

export default ReportDownloadActions;
